/*
* Copyright (C) Regione Lombardia
*/
import { Component } from '@angular/core';

@Component({
    selector: 'app-pages-cms-accessibilita',
    templateUrl: './accessibilita.component.html',
})
export class PagesCmsAccessibilitaComponent { }
